<template>
  <div
    v-if="content"
    :class="{
      'callout-banner mx-auto mb-7 flex w-fit max-w-full items-baseline gap-10px rounded-full border': true,
      'px-4 py-6px': true,
    }"
  >
    <span
      aria-hidden="true"
      :class="{
        'h-2 w-2 shrink-0 rounded-full bg-www-color-primary-lighter opacity-50': true,
      }"
    ></span>
    <p
      :class="{
        'whitespace-pre-line text-center text-xs font-bold uppercase tracking-[1.92px] text-www-color-primary-pale': true,
      }"
    >
      {{ content }}
    </p>
  </div>
</template>

<script setup lang="ts">
import type { CalloutBanner } from '~/sanity/types';

defineProps<CalloutBanner>();
</script>

<style lang="scss" scoped>
.callout-banner {
  /* translucent so the hero video stays visible behind the pill */
  background-color: rgb(23 33 23 / 55%);
  border-color: rgb(154 217 135 / 30%);
}
</style>
